import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

export const radioGroupVariants = tv({
	slots: {
		grid: "grid gap-1",
		option: [
			"flex items-center justify-center rounded-md p-2 text-xs font-semibold sm:flex-1",
			"focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-white",
		],
		label: "",
	},
	variants: {
		numCols: {
			2: { grid: "grid-cols-2" },
			3: { grid: "grid-cols-3" },
			4: { grid: "grid-cols-4" },
			5: { grid: "grid-cols-5" },
		},
		checked: {
			true: {
				option: "bg-primary-500 text-white",
			},
			false: {
				option: "bg-white text-gray-900 ring-1 ring-inset ring-gray-300",
			},
		},
		interactive: {
			true: {
				option: "cursor-pointer",
			},
			false: {
				option: "cursor-default",
			},
		},
	},
	compoundVariants: [
		{
			checked: true,
			interactive: true,
			class: {
				option: "hover:bg-primary-700",
			},
		},
		{
			checked: false,
			interactive: true,
			class: {
				option: "hover:bg-gray-50",
			},
		},
	],
	defaultVariants: {
		numCols: 4,
		checked: false,
		interactive: true,
	},
});

export type RadioGroupVariantProps = VariantProps<typeof radioGroupVariants>;